'use client';

import { ServiceModules, type ServiceModulesContent } from '../components';

const SOURCING_SERVICE_CONTENT: ServiceModulesContent = {
  layout: {
    nextLink: '/ip',
    hoverTextColor: 'text-at',
    logoColor: 'text-at',
  },
  hero: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/sourcing_waves.jpg',
    headingStatement: 'Building teams that work',
    heading: 'Sourcing + Recruiting',
    headingLargeText: 'There’s more to excellent hiring than ticking boxes or leaning on algorithms.',
    headingSmallText:
      'All Turtles takes the guesswork out of hiring by proactively sourcing for hard-to-find roles. Our deep network and decade of experience in product-led startups, working with or as founders, means we identify, engage, and place top talent in less time and at a better value.',
    imageTopOffset: 576,
  },
  teamProof: {
    text: 'Our team has provided full-cycle recruiting services for hundreds of positions, with a 74% job fill rate and 91% offer acceptance rate.',
  },
  whatWeDo: {
    boldTitle: 'Recruiting expertise',
    textParagraphs: [
      'Whether you need full-cycle recruitment as a temporary CPO or staff partner, All Turtles will help you define your needs, develop a detailed job description, build a custom search strategy, and find and qualify the best possible talent for your organization in the shortest timeframe.',
    ],
    ctaText: 'Let’s build your team',
    ctaLink: 'mailto:hello@all-turtles.com?subject=Sourcing%20and%20Recruiting%20inquiry',
    rightColumnItems: [
      {
        heading: 'Full-cycle recruiting',
        paragraph:
          'Our recruiters work directly with companies to define roles, develop candidate profiles, source, screen, interview, and negotiate offers—helping you land top talent quickly and efficiently. We also handle background checks and offer letters.',
      },
      {
        heading: 'Supplemental recruiting',
        paragraph:
          'Need to fill specific roles, but don’t have enough bandwidth? Our recruiters can jump in to cover a defined portion of the search, like sourcing, screening, interviewing, or onboarding.',
      },
      {
        heading: 'Consulting',
        paragraph:
          'From the initial stages of defining job requirements to final offer negotiation, our team will provide guidance and support throughout the entire hiring process—helping you make the best decisions for your organization.',
      },
    ],
  },
  whatMakesUsUnique: {
    points: [
      {
        boldPhrase: 'Responsive to everyone’s time',
        description:
          'We’ve streamlined our recruitment process to ensure fast turnarounds, from initial contact to offer, without compromising quality.',
      },
      {
        boldPhrase: 'A diverse perspective',
        description:
          'Our team is committed to helping you create a diverse and inclusive workforce. We proactively seek out candidates from underrepresented groups and promote equitable hiring practices.',
      },
      {
        boldPhrase: 'A true partnership',
        description:
          'Our goal is to help you create a long-term, successful recruiting strategy. We work closely with you every step of the way to ensure we’re delivering the best possible talent for your team.',
      },
    ],
  },
  allTurtlesInAction: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/sourcing_carrot.png',
    mobileBackgroundImage: '/images/services/sourcing_carrot.png',
    title: 'Helping Carrot build a world-class team',
    paragraphs: [
      [
        {
          type: 'link',
          href: 'https://all-turtles.com/carrot',
          text: 'Carrot Fertility',
        },
        {
          type: 'text',
          value:
            ', the world’s leading global fertility benefits provider, helps employers worldwide offer comprehensive family-forming solutions, with more than 800 employers across 50+ countries. When Carrot started its mission to make fertility care more accessible, they partnered with All Turtles to build their core team.',
        },
      ],
      'Our ample experience in product-led startups, combined with Carrot’s innovative approach, quickly led to securing top talent across engineering, product, and design roles. We worked closely with their leadership to identify key hires, attract top talent, and build a world-class team that could scale with their rapid growth. All Turtles is proud to have helped Carrot build a team that is making a real difference in people’s lives around the world.',
    ],
    testimonialPhoto: '/images/services/sourcing_tammy.png',
    testimonialPhotoAlt: 'Tammy Sun, Founder & CEO, Carrot Fertility',
    testimonialQuote:
      'All Turtles has been a key partner. I would highly recommend their team to any organization looking to hire fast and smart.',
    testimonialPerson: 'Tammy Sun',
    testimonialTitle: 'Founder & CEO, Carrot Fertility',
  },
};


export const ServicePage = () => {
  return <ServiceModules content={SOURCING_SERVICE_CONTENT} />;
};
